import React from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";

const RegistrationError = () => {
    const originSiteUrl = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.originSiteUrl
            ? state.configurationState.configuration.partnerConfig.originSiteUrl
            : ""
    );

    const isPartnerIdIsTransunion = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2649
                ? true
                : false
            : false
    );

    return (
        <div className="row margin-vertical-xl registration-error">
            <div className={`box box-has-shadow box-lg`}>
                <div className="box-content">
                    <p className="margin-bottom-xs">There was an unexpected error in your enrollment.</p>

                    <h3 className="content-title">Did you come from an email?</h3>
                    <p className="margin-bottom-xs">
                        If you came to this page through an email, please go back to that email and click on the link provided to make sure you receive your special
                        offer.
                    </p>

                    <h3 className="content-title">Did you come from another website?</h3>
                    <p className="margin-bottom-xs">
                        If you came to this page through another website it's possible a special service was being offered to you. Please go back to where you came
                        from to make sure you claim your full benefits.
                    </p>

                    <h3 className="content-title">Did you come from our homepage?</h3>
                    <p className="margin-bottom-xs">
                        <a href={isPartnerIdIsTransunion ? 'https://www.identityforce.com/' : `https://${originSiteUrl}`} className="default_link">
                            {" "}
                            Click here{" "}
                        </a>{" "}
                        to return to the home page to re-select the package that is best for you
                    </p>
                </div>
            </div>
        </div>
    );
};

export default RegistrationError;
